<!-- App Main Structure -->
<template>
    <div class="app-default-layout">
      <template>
        <div class="header">
            <a href="/agency/mypage"><img class="icon m-3" alt="Aeru_logo" src="../assets/top/PC_mobile/images/logo.png"></a>
        </div>
        <b-container fluid class='px-0'>
          <b-row v-if='!this.unShowList.includes(this.$route.path)' style="height: 100%">
            <b-col cols='2' class='px-0 side-bg-color'>
              <side-menu></side-menu>
            </b-col>
            <b-col cols='10' class='px-0 main-area'>
              <router-view></router-view>
            </b-col>
          </b-row>

          <b-row v-else>
            <b-col cols='12' class='px-0'>
              <router-view></router-view>
            </b-col>
          </b-row>
        </b-container>
        <app-footer></app-footer>
      </template>
    </div>
</template>

<script>
// import Header from "Components/User/Header.vue";
import Footer from "Components/Organization/Footer.vue";
import SideMenu from "Components/Agency/SideMenu.vue";
import moment from 'moment';
export default {
  data() {
    return {
      loading: true,
      unShowList: ['/agency/startup', '/agency/organizationTop', '/agency', '/agency/addOrganizationInfo'],
      sideCols: 2
    };
  },
  components: {
    // appHeader: Header,
    appFooter: Footer,
    SideMenu
  },
  mounted(){
    this.switchAuth("organization")
     moment.locale("ja", {
      weekdays: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
      weekdaysShort: ["日", "月", "火", "水", "木", "金", "土"]
    });
  },

};
</script>

<style scoped>
.app-default-layout {
  height: 100vh;
  white-space:pre-line;
}

.header{
  background-color: #000054;
  height: 65px;
}

.icon{
  height: 35px !important;
}

.side-bg-color{
  background-color: #707589;
}

.main-area {
  min-height: 90vh;
  position: relative;
  box-sizing: border-box;
}
</style>
